import { connect } from 'react-redux';
import { SizeOption } from './component';
import { getSizeItems } from './selectors';
import { changePageSize } from '../actions';
const mapStateToProps = (state, props) => {
    return {
        // TODO zrusit selector a pocitat to primo v reducers/page
        value: state.page.size,
        items: getSizeItems(state, props.locale),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (e) => {
            dispatch(changePageSize(e.target.value));
        },
    };
};
export const SizeOptionContainer = connect(mapStateToProps, mapDispatchToProps)(SizeOption);
//# sourceMappingURL=container.js.map